import { getExperienceMobileAppDiscountTotal, getTransferMobileAppDiscountTotal } from 'checkout/selectors/view/experience'
import { excludeNullOrUndefined } from 'checkout/utils'
import { sum } from 'lib/array/arrayUtils'
import { isExperienceItem } from 'lib/checkout/checkoutUtils'
import { createSelector } from 'reselect'
import getExperienceItemsView from '../view/itemViews/getExperienceItemsView'
import getTransferItemsView from '../view/itemViews/getTransferItemsView'
import { checkoutWithMemberPrice, getHasLuxPlusOrSubscriptionInCart } from '../view/luxPlusSubscription'

export const isStandaloneExperiences = createSelector(
  (state: App.State) => state.checkout.cart.items,
  (items): boolean => items.length > 0 && items.every(isExperienceItem),
)

export const getExperienceTotals = createSelector(
  (state: App.State) => getExperienceItemsView(state),
  (state: App.State) => getExperienceMobileAppDiscountTotal(state),
  (state: App.State) => checkoutWithMemberPrice(state),
  (state: App.State) => getHasLuxPlusOrSubscriptionInCart(state),
  (viewWithStatus, mobileAppDiscountTotals, checkoutWithMemberPrice, hasLuxPlusOrSubscriptionInCart): App.WithDataStatus<App.Checkout.ItemViewTotals> => {
    const definedItems = viewWithStatus.data
      .filter(excludeNullOrUndefined)
      .filter(item => !item.item.isAccomBundle && !item.item.experiencesPassport)

    const taxesAndFees = sum(definedItems.flatMap(item => item.ticketViews.map(view => view.totals.taxesAndFees)))
    const price = sum(definedItems, itemView => itemView.totals.price)
    const value = sum(definedItems, itemView => itemView.totals.value)
    const memberPrice = sum(definedItems, itemView => itemView.totals.memberPrice || itemView.totals.price)
    const memberValue = sum(definedItems, itemView => itemView.totals.memberValue)

    return {
      hasRequiredData: viewWithStatus.hasRequiredData,
      data: {
        price: checkoutWithMemberPrice && memberPrice > 0 ? memberPrice : price,
        memberPrice,
        value: hasLuxPlusOrSubscriptionInCart ? memberValue : value,
        surcharge: 0,
        taxesAndFees,
        mobileAppDiscount: mobileAppDiscountTotals,
        memberValue: 0,
        extraGuestSurcharge: 0,
      },
    }
  },
)

export const getTransferTotals = createSelector(
  (state: App.State) => getTransferItemsView(state),
  (state: App.State) => getTransferMobileAppDiscountTotal(state),
  (state: App.State) => checkoutWithMemberPrice(state),
  (state: App.State) => getHasLuxPlusOrSubscriptionInCart(state),
  (viewWithStatus, mobileAppDiscountTotals, checkoutWithMemberPrice, hasLuxPlusOrSubscriptionInCart): App.WithDataStatus<App.Checkout.ItemViewTotals> => {
    const definedItems = viewWithStatus.data.filter(excludeNullOrUndefined).filter(item => !item.item.isAccomBundle)

    const taxesAndFees = sum(definedItems, itemView => itemView.totals.taxesAndFees)
    const price = sum(definedItems, itemView => itemView.totals.price)
    const value = sum(definedItems, itemView => itemView.totals.value)
    const memberPrice = sum(definedItems, itemView => itemView.totals.memberPrice || itemView.totals.price)
    const memberValue = sum(definedItems, itemView => itemView.totals.memberValue)

    return {
      hasRequiredData: viewWithStatus.hasRequiredData,
      data: {
        price: checkoutWithMemberPrice && memberPrice > 0 ? memberPrice : price,
        memberPrice,
        value: hasLuxPlusOrSubscriptionInCart ? memberValue : value,
        surcharge: 0,
        taxesAndFees,
        mobileAppDiscount: mobileAppDiscountTotals,
        memberValue: 0,
        extraGuestSurcharge: 0,
      },
    }
  },
)
